export default "__VITE_ASSET__BOJoLyDp__"